var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdpSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.124023,
    y: 8.52362,
    width: 4.63414,
    height: 0.614752,
    rx: 0.307376,
    fill: "#616161"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.349854,
    y: 1.90186,
    width: 5.22488,
    height: 0.699687,
    rx: 0.349843,
    transform: "rotate(30 0.349854 1.90186)",
    fill: "#616161"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.22488,
    height: 0.699687,
    rx: 0.349843,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 4.5249 1.90186)",
    fill: "#616161"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.78735,
    y: 0.861816,
    width: 5.22488,
    height: 0.699687,
    rx: 0.349843,
    transform: "rotate(90 2.78735 0.861816)",
    fill: "#616161"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.83997,
    y: 8.67731,
    width: 4.32677,
    height: 0.307376,
    rx: 0.153688,
    fill: "#577590",
    stroke: "#F38181",
    strokeWidth: 0.307376
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9126,
    y: 1.90186,
    width: 5.22488,
    height: 0.699687,
    rx: 0.349843,
    transform: "rotate(30 5.9126 1.90186)",
    fill: "#F38181"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -0.0640258,
    y: 0.238947,
    width: 4.87504,
    height: 0.349843,
    rx: 0.174922,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 9.84845 1.96588)",
    fill: "#577590",
    stroke: "#F38181",
    strokeWidth: 0.349843
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.17493,
    y: 1.03674,
    width: 4.87504,
    height: 0.349843,
    rx: 0.174922,
    transform: "rotate(90 8.17493 1.03674)",
    fill: "#577590",
    stroke: "#F38181",
    strokeWidth: 0.349843
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.249,
    y: 8.52362,
    width: 4.63414,
    height: 0.614752,
    rx: 0.307376,
    fill: "#616161"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4749,
    y: 1.90186,
    width: 5.22488,
    height: 0.699687,
    rx: 0.349843,
    transform: "rotate(30 11.4749 1.90186)",
    fill: "#616161"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 5.22488,
    height: 0.699687,
    rx: 0.349843,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 15.6501 1.90186)",
    fill: "#616161"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9124,
    y: 0.861816,
    width: 5.22488,
    height: 0.699687,
    rx: 0.349843,
    transform: "rotate(90 13.9124 0.861816)",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpSvg);
export default __webpack_public_path__ + "static/media/mdp-svg.7df91c15.svg";
export { ForwardRef as ReactComponent };